/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useRef } from 'react';

import { usePageNavigation } from 'bundles/unified-description-page-common/contexts/PageNavigationContext';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

type Props = {
  children: React.ReactNode;
  anchorId?: string;
  spacing?: number;
};

const styles = {
  section: (spacing: number, fixedPageNavHeight?: number) => css`
    margin: ${spacing}px 0;
    scroll-margin-top: ${fixedPageNavHeight ? fixedPageNavHeight + 24 : 132}px;
  `,
};

const Section = React.forwardRef(({ children, anchorId, spacing }: Props, ref?: React.Ref<HTMLDivElement>) => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { enableXDPRedesignPhase1 } = useXDPRedesignPhase1Data();

  let updatedSpacing = spacing;
  if (spacing === undefined) {
    // 36 is the base spacing for the redesign, but needs to be offset
    // from the grid spacing
    updatedSpacing = enableXDPRedesignPhase1 ? 24 : 48;
  }

  const { addSectionElementRef, fixedPageNavHeight } = usePageNavigation();

  useEffect(() => {
    if (sectionRef.current && addSectionElementRef && anchorId) {
      addSectionElementRef(anchorId, sectionRef.current);
    }
  }, [addSectionElementRef, anchorId]);

  return (
    <div css={styles.section(updatedSpacing as number, fixedPageNavHeight)} id={anchorId} ref={sectionRef}>
      <div ref={ref}>{children}</div>
    </div>
  );
});

export default Section;
